// src/components/ui/EmptyState.tsx
//
// Empty-state placeholder (no results, no data, etc).

import type { ReactNode } from "react";
import { Inbox } from "lucide-react";

export interface EmptyStateProps {
  title: string;
  description?: string;
  icon?: ReactNode;
  action?: ReactNode;
}

export function EmptyState({
  title,
  description,
  icon,
  action,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-4 rounded-lg border border-dashed border-border bg-bg-panel/50 px-6 py-16 text-center">
      <div className="flex h-12 w-12 items-center justify-center rounded-full bg-bg-elevated text-fg-tertiary">
        {icon ?? <Inbox className="h-5 w-5" strokeWidth={1.5} />}
      </div>
      <div className="space-y-1">
        <h3 className="text-sm font-510 text-fg-primary">{title}</h3>
        {description && (
          <p className="text-xs text-fg-tertiary">{description}</p>
        )}
      </div>
      {action}
    </div>
  );
}
